import { Box } from "@mui/material";
import React from "react";
import TabButton from "./TabButton";

interface Props {
  handleChangeTab: (index: number) => void;
  buttons: {
    title: string;
  }[];
  activeIndex: number;
}

export default function ButtonTabbar({
  buttons,
  handleChangeTab,
  activeIndex,
}: Props) {
  return (
    <Box
      sx={{
        marginX: "8px",
        backgroundColor: "info.light",
        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
        borderRadius: "10px",
        display: "flex",
        padding: "6px 8px 6px 8px",
        gap: "4px",
      }}
    >
      {buttons.map((item, index) => (
        <TabButton
          handleClick={(index) => handleChangeTab(index)}
          title={item.title}
          index={index}
          active={index === activeIndex}
        />
      ))}
    </Box>
  );
}
